export default __webpack_public_path__ + "static/media/2689520-ai (1) (1).47379368.png";